import { __extends } from "tslib";
import { MessageAwareBase } from '../core/message-aware-base';
import { createQueryString, generateGuid, parseOriginFromUrl } from '../utils';
import { DEFAULT_IFRAME_STYLES, ParameterType } from '../core';
import { AlreadyDisposedError, NotLoadedError } from '../core/errors';
var TylerEmbeddedApplicationHost = /** @class */ (function (_super) {
    __extends(TylerEmbeddedApplicationHost, _super);
    function TylerEmbeddedApplicationHost() {
        var _this = _super.call(this) || this;
        if (TylerEmbeddedApplicationHost.instance) {
            return TylerEmbeddedApplicationHost.instance;
        }
        _this._hostId = generateGuid();
        TylerEmbeddedApplicationHost.instance = _this;
        return _this;
    }
    TylerEmbeddedApplicationHost.prototype.createUri = function (uri, params) {
        var _a;
        if (params === void 0) { params = {}; }
        this._origin = parseOriginFromUrl(uri);
        var queryParams = {};
        var hostParams = (_a = {},
            _a[this.getParameterName(ParameterType.HostId)] = this._hostId,
            _a[this.getParameterName(ParameterType.Origin)] = this._getCurrentOrigin(),
            _a);
        Object.assign(queryParams, params, hostParams);
        var queryStringExists = uri.indexOf('?') >= 0;
        if (!queryStringExists) {
            uri = uri.replace(/\/?$/, '');
        }
        return uri + createQueryString(queryParams, queryStringExists);
    };
    /** Attempt to create a unique name for the embedded application based on the path. */
    TylerEmbeddedApplicationHost.prototype.createName = function (uri) {
        var name = '';
        var url = new URL(uri);
        var pathname = decodeURIComponent(url.pathname).trim();
        if (pathname !== '' && pathname !== '/') {
            var fragments = pathname.split('/');
            name = fragments.filter(function (f) { return f !== ''; }).join('-');
            name = name.replace(' ', '-');
        }
        return name;
    };
    TylerEmbeddedApplicationHost.prototype.create = function (uri, params, element, styles) {
        return this.createEmbeddedContext(uri, params, element, styles);
    };
    TylerEmbeddedApplicationHost.prototype.load = function (uri, params, element, styles) {
        var iframe = this.createEmbeddedContext(uri, params, element, styles);
        iframe.load();
        return iframe;
    };
    /**
     * @deprecated use iframe.registerMessageListener(...) to support listening to multiple embedded apps
     * */
    TylerEmbeddedApplicationHost.prototype.registerMessageListener = function (type, listener) {
        _super.prototype.registerMessageListener.call(this, type, listener);
    };
    TylerEmbeddedApplicationHost.prototype.createEmbeddedContext = function (uri, params, element, styles) {
        var _a;
        var _this = this;
        if (styles === void 0) { styles = {}; }
        var iframe = document.createElement('iframe');
        Object.assign(iframe.style, DEFAULT_IFRAME_STYLES, styles);
        iframe.id = (params === null || params === void 0 ? void 0 : params[this.getParameterName(ParameterType.EmbeddedId)]) || generateGuid();
        params = Object.assign((_a = {}, _a[this.getParameterName(ParameterType.EmbeddedId)] = iframe.id, _a), params);
        var name = this.createName(uri);
        if (name) {
            iframe.name = name;
        }
        if (element) {
            element.appendChild(iframe);
        }
        iframe.load = function () {
            if (iframe.disposed) {
                throw new AlreadyDisposedError();
            }
            iframe.src = _this.createUri(uri, params);
            iframe.loaded = true;
        };
        iframe.message = function (type, data) {
            if (iframe.disposed) {
                throw new AlreadyDisposedError();
            }
            if (!iframe.loaded || !iframe.contentWindow) {
                throw new NotLoadedError();
            }
            var message = _this.createMessage(_this.getEventName(type), data);
            iframe.contentWindow.postMessage(message, _this._origin);
        };
        /**
         * Registers a listener for a specific message type that could be dispatched from embedded context.
         * @param {string} type The message type identifier.
         * @param {} listener The listener to be executed when receiving a message
       */
        iframe.registerMessageListener = function (type, listener) {
            if (iframe.disposed) {
                throw new AlreadyDisposedError();
            }
            _super.prototype.registerMessageListener.call(_this, "".concat(type, "-").concat(iframe.id), listener);
        };
        iframe.dispose = function () {
            for (var _i = 0, _a = _this.messageNames; _i < _a.length; _i++) {
                var type = _a[_i];
                _this.deregisterMessageListener("".concat(type, "-").concat(iframe.id));
            }
            iframe.remove();
            iframe.disposed = true;
        };
        return iframe;
    };
    return TylerEmbeddedApplicationHost;
}(MessageAwareBase));
export { TylerEmbeddedApplicationHost };
